import { render, staticRenderFns } from "./ImageWithTable.vue?vue&type=template&id=747e9d13&scoped=true"
import script from "./ImageWithTable.vue?vue&type=script&lang=js"
export * from "./ImageWithTable.vue?vue&type=script&lang=js"
import style0 from "./ImageWithTable.vue?vue&type=style&index=0&id=747e9d13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747e9d13",
  null
  
)

export default component.exports